import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-close\"><path d=\"M13.12 12.88c.3-.3.317-.793.03-1.08L8.26 6.91l4.853-4.854A.786.786 0 0 0 13.12.964a.781.781 0 0 0-1.092.007L7.174 5.824 2.28.93C1.991.641 1.5.66 1.2.96c-.307.305-.318.792-.03 1.08l4.895 4.895-4.853 4.854c-.295.295-.312.799-.013 1.098.294.293.803.282 1.098-.012L7.15 8.02l4.89 4.89c.287.287.774.276 1.08-.03Z\" fill=\"#05191F\" stroke=\"#05191F\" stroke-width=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol